export function stripLeadingQuestionNumber(text: string | null | undefined): string {
  if (!text) return ''

  return text.replace(
    /^\s*(?:[•*-]\s*)?(?:\[\s*\d+\s*[\.\)]?\s*\](?:\s*[\.\)])?|\(\s*\d+\s*[\.\)]?\s*\)(?:\s*[\.\)])?|\d+\s*[\.\)])\s*/,
    '',
  )
}
